module.exports = __webpack_public_path__ + "media/images/icon/house-64cedd87f92cae1f1d1683741a82b322.svg";